import {
  CanActivate,
} from "@angular/router";
import { Observable, combineLatest } from "rxjs";
import { Injectable } from "@angular/core";
import { map, take } from "rxjs/operators";
import {
  SessionStorageKey,
  SessionStorageState,
  IdentityVerificationAction,
  
  SsoAccountFacade,
  AgreementSigningStatus
} from "common";
import { IdentityNavigationService } from "../../features/identity-verification/services/identity-navigation.service";

@Injectable({
  providedIn: "root",
})
export class ApplicationAgreementSignedGuard implements CanActivate {
  constructor(
    private identityNavigationService: IdentityNavigationService,
    private ssoAccountFacade: SsoAccountFacade
  ) {}

  canActivate(
  ): Observable<boolean> | boolean {
    if (SessionStorageState.get(SessionStorageKey.ApplicationAgreementViewed)) {
      return true;
    }
    return combineLatest([
      this.ssoAccountFacade.getSsoAccountCheckoutState$(), 
      this.ssoAccountFacade.getCurrentSsoAccount$()
    ])
    .pipe(
      take(1),
      map(([checkoutState, currentAccount]) => {
        const pendingApplication = currentAccount?.pendingApplications?.find(
          app => app.agreementSigningStatus === AgreementSigningStatus.PendingCurrentUser
        );

        if (pendingApplication && checkoutState.identityVerificationAction === IdentityVerificationAction.Skip) {
          this.identityNavigationService.signApplicationAgreement({ 
            applicationId: pendingApplication.applicationId 
          });
          return false;
        }
        return true;
      })
    );
  }
}
